import QuotePersistenceGate from '#client/App/Quote/QuotePersistenceGate';
import CartError from '#client/components/CartError';
import FlowConfigBase from '#client/config/FlowConfigBase';
import AUTH_POLICY from '#client/constants/authPolicy';
import * as ROUTES from '#client/constants/routes';

import PAGES, { PAGE_KEYS } from '../flowPageConfig';

export default FlowConfigBase.createEntry({
  id: 'llc-verizon',
  pageKeys: [PAGE_KEYS.BUSINESS_INFO, PAGE_KEYS.CHECKOUT],
  pageConfigs: {
    [PAGES.BUSINESS_INFO.pageComponent]: {
      pageComponentProps: {
        shouldUpdateJurisdictionState: true
      }
    },
    [PAGES.CHECKOUT.pageComponent]: {
      pageComponentProps: {
        slotProps: {
          businessCardProps: {
            contactInfoFields: {
              firstName: { disabled: true },
              lastName: { disabled: true },
              email: { disabled: true },
              phone: { disabled: true }
            }
          }
        }
      }
    }
  },
  authRedirect: false,
  authPolicy: AUTH_POLICY.NOT_ALLOWED,
  entityType: 'llc',
  isPrimary: true,
  postOrderAutoLogin: true,
  disableCartCreation: true,
  disableLeadManager: true,
  postOrderRedirect: `${ROUTES.SHOP_LLC_ADDONS}`,
  priceListUuids: {
    development: null,
    production: null
  },
  persistenceGate: QuotePersistenceGate,
  errorBoundaryFallback: CartError
});
